<div class="container">
  <div class="close" (click)="dialogRef.close()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <p class="title">{{ data.title }}</p>
  <div class="receive" *ngIf="data.isGroup">
    <p class="text">Vas a recibir</p>
    <p class="amount">
      {{
        (data.operation === 'BUY'
          ? data.srcCoinAmount / data.price
          : data.srcCoinAmount * data.price
        ) | formatCoinAmount : data.destCoin + ' ' + data.destCoin
      }}
      <img [src]="'/assets/icons/crypto/' + data.destCoin.toLowerCase() + '.svg'" alt="src" />
    </p>
  </div>
  <div class="coins-container">
    <ng-container *ngIf="data.isGroup; else notGroup">
      <div class="coins-group">
        <div class="contain">
          <span class="exchange-text">Vas a cambiar</span>
          <div class="coin-info">
            <p class="coin-detail">
              {{ data.srcCoinAmount | number : '0.0-6' }} {{ data.srcCoin }}
              <img
                [src]="'/assets/icons/crypto/' + data.srcCoin.toLowerCase() + '.svg'"
                alt="src"
              />
            </p>
          </div>
        </div>
        <div class="contain">
          <span class="exchange-text">Cotización</span>
          <div class="coin-info">
            <p class="coin-detail">
              1 {{ data.currentCoinPair.split('_')[0] }} ≈
              {{ data.price | number : '0.3-3' }}
              {{ data.currentCoinPair.split('_')[1] }}
            </p>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #notGroup>
      <span class="exchange-text">Entregás</span>
      <div class="coin-info">
        <img [src]="'/assets/icons/crypto/' + data.srcCoin.toLowerCase() + '.svg'" alt="src" />
        <p class="coin-detail">{{ data.srcCoinAmount | number : '0.0-6' }} {{ data.srcCoin }}</p>
      </div>
      <span class="exchange-text">Recibís</span>
      <div class="coin-info">
        <img [src]="'/assets/icons/crypto/' + data.destCoin.toLowerCase() + '.svg'" alt="src" />
        <p class="coin-detail">
          {{ data.destCoinAmount | formatCoinAmount : data.destCoin }}
          {{ data.destCoin }}
        </p>
      </div>
    </ng-template>
  </div>
  <div class="price-section">
    <p *ngIf="!priceExpired" class="timer">
      <ng-container *ngIf="!data.isGroup">
        1
        {{ data.currentCoinPair.split('_')[0] }}
        ≈
        {{ data.price | formatCoinAmount : data.currentCoinPair.split('_')[0] }}
        {{ data.currentCoinPair.split('_')[1] }}
      </ng-container>
      <span>
        {{
          data.isGroup ? 'Oferta válida por ' + countDownSecond : 'válido por ' + countDownSecond
        }}s</span
      >
    </p>
    <p *ngIf="priceExpired" class="confirm-text">Precio actual vencido</p>
    <p class="confirm-text" [class.expired]="priceExpired">¿Desea realizar la operación?</p>
    <p *ngIf="showError" class="error">{{ errorText }}</p>
  </div>
  <button
    *ngIf="!isProcessing; else trxProcessing"
    class="td-btn primary"
    [class.expired]="priceExpired"
    [class.disabled]="!firstLockOrderDone"
    (click)="priceExpired ? getNewPrice() : confirmSwap()"
    [ngClass]="{
      'btn-group': data.isGroup
    }"
  >
    {{ getButtonText() }}
  </button>
  <ng-template #trxProcessing>
    <div class="loading">
      <div class="circle-loader">
        <div class="checkmark draw"></div>
      </div>
    </div>
  </ng-template>
</div>
